// Mobile menu
document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('.site-header');

	if (!header) return;

	const toggle = header.querySelector('.toggle');
	const bar = header.querySelector('.container');
	const actions = header.querySelector('.actions');
	const desktop = window.matchMedia('(min-width: 992px)');

	// The open mobile menu sits between the logo bar and the pinned buttons
	const measure = () => {
		header.style.setProperty('--header-bar', `${bar.offsetHeight}px`);
		header.style.setProperty('--header-actions', `${actions.offsetHeight}px`);
	};

	const setOpen = (open) => {
		header.classList.toggle('is-open', open);
		document.documentElement.classList.toggle('menu-open', open);
		toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
		toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');

		if (open) requestAnimationFrame(measure);
	};

	toggle.addEventListener('click', () => setOpen(!header.classList.contains('is-open')));

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && header.classList.contains('is-open')) {
			setOpen(false);
			toggle.focus();
		}
	});

	header.querySelectorAll('.primary a, .actions a').forEach((link) => {
		link.addEventListener('click', () => setOpen(false));
	});

	desktop.addEventListener('change', () => setOpen(false));
	window.addEventListener('resize', () => header.classList.contains('is-open') && measure());
});


// Marks Gravity Forms fields as filled, so their labels stay shrunk at the top
(() => {
	const selector = '.gform_wrapper .gfield input, .gform_wrapper .gfield textarea';

	const update = (input) => {
		const field = input.closest('.gfield');

		if (field) field.classList.toggle('is-filled', input.value.trim() !== '');
	};

	const updateAll = () => document.querySelectorAll(selector).forEach(update);

	['input', 'change', 'focusout'].forEach((event) => {
		document.addEventListener(event, (e) => {
			if (e.target.matches && e.target.matches(selector)) update(e.target);
		});
	});

	document.addEventListener('DOMContentLoaded', updateAll);

	// Gravity Forms re-renders the form after an AJAX submit with errors
	if (window.jQuery) window.jQuery(document).on('gform_post_render', updateAll);
})();
